module.exports = __webpack_public_path__ + "img/bonds of blood_.98712c6c.png";